
import React from 'react';

const TrashIcon = ({ width = 51, height = 56, color = "#A5A5A5" }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 51 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_143_324)">
                <path d="M51 9.33333H37.0909V4.66667C37.0909 2.17778 34.9273 0 32.4545 0H18.5455C16.0727 0 13.9091 2.17778 13.9091 4.66667V9.33333H0V14H3.70909L7.72727 49.7778C8.03636 53.2 11.1273 56 14.5273 56H36.1636C39.5636 56 42.6545 53.2 42.9636 49.7778L46.9818 14H51V9.33333ZM18.5455 4.66667H32.4545V9.33333H18.5455V4.66667ZM38.6364 49.1556C38.6364 50.4 37.4 51.3333 36.4727 51.3333H14.8364C13.6 51.3333 12.6727 50.4 12.6727 49.1556L8.34545 14H42.3455L38.6364 49.1556ZM16.3818 38.5778L22.2545 32.6667L16.3818 26.7556L19.7818 23.3333L25.6545 29.2444L31.5273 23.3333L34.9273 26.7556L29.0545 32.6667L34.9273 38.5778L31.5273 42L25.6545 36.0889L19.7818 42L16.3818 38.5778Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_143_324">
                    <rect width={51} height={56} fill="white" />
                </clipPath>
            </defs>
        </svg>



    );
};

export default TrashIcon;


